const stats = [
  {
    num: "7 yrs",
    cap: "In accounting and finance before software. I read the ledger, not just the ticket.",
  },
  {
    num: "5 yrs",
    cap: "Building the software since 2021. The same hands stay on the reconciliation and on the deployment.",
  },
  {
    num: "24 h",
    cap: "Typical reply time, usually with questions before any invoice.",
  },
];

export default function Stats() {
  return (
    <section className="t-sec" aria-labelledby="stats-title">
      <div className="t-wrap">
        <div className="t-block-head">
          <h2 id="stats-title" className="t-h2 t-rise">
            One person, start to finish.
          </h2>
        </div>

        <dl className="t-stats t-gap-top">
          {stats.map((stat) => (
            <div className="t-stat t-rise" key={stat.num}>
              <dt className="t-stat__num">{stat.num}</dt>
              <dd className="t-stat__cap">{stat.cap}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
